import { render, staticRenderFns } from "./ECampoDesconto.vue?vue&type=template&id=15dc4b48"
import script from "./ECampoDesconto.vue?vue&type=script&lang=js"
export * from "./ECampoDesconto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports